<template>
    <div>
        <kgr-empty
            v-if="fields.length === 0"
            :value="$t('field.noResults')"
        />

        <div v-else>
            <kgr-fields-table
                v-if="view === 'list'"
                :fields="fields"
                :filter="filter"
            />

            <kgr-fields-grid
                v-if="view === 'grid'"
                :fields="fields"

                :filter="filter"
            />
        </div>
    </div>
</template>

<script>
import EmptyData from '../common/EmptyData';
import KgrFieldsGrid from './FieldsGrid';
import KgrFieldsTable from './FieldsTable';

export default {
    name: 'KgrFieldList',
    components: {
        'kgr-fields-table': KgrFieldsTable,
        'kgr-fields-grid': KgrFieldsGrid,
        'kgr-empty': EmptyData,
    },
    props: {
        fields: {
            type: Array,
            required: true,
        },
        filter: {
            type: String,
            required: false,
            default: null,
        },
        view: {
            type: String,
            required: true,
        },
    },
}
</script>
